import { css, px } from '@jd/jmtd-tools/es/css'; // 对其宽度

export default function alignWidth(nodeList) {
  if (!nodeList.length) {
    return;
  }

  var widthList = [];
  nodeList.forEach(function (node) {
    css(node, 'width', 'fit-content');
    widthList.push(node.clientWidth);
  });
  var maxWidth = Math.ceil(Math.max.apply(Math, widthList));
  nodeList.forEach(function (node) {
    css(node, 'width', px(maxWidth));
  });
}